<p-dialog
  header="{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.DIALOG_HEADER' | translate }}"
  [(visible)]="display"
  [modal]="true"
  [draggable]="false"
  class="admin-dialog">
  <form [formGroup]="ageRangeForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.GROUP_TYPE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-select-age-group-type [parentForm]="ageRangeForm"
                                       (onChange)="onChange()"></wsd-select-age-group-type>
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ (show ? 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.AGE_GROUP_NAME' : 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.GROUP_NAME') | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-extended-input [control]="ageRangeForm.get('ageGroupName')">
              <input pInputText
                     formControlName="ageGroupName"/>
            </wsd-extended-input>
          </div>
        </div>
      </div>
      <div class="ui-g-12" *ngIf="show">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.STARTING_AGE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-extended-input [control]="ageRangeForm.get('startingAge')">
              <input pInputText type="number"
                     formControlName="startingAge">
            </wsd-extended-input>
          </div>
        </div>
      </div>
      <div class="ui-g-12" *ngIf="show">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.ENDING_AGE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-extended-input [control]="ageRangeForm.get('endingAge')">
              <input pInputText type="number"
                     formControlName="endingAge">
            </wsd-extended-input>
          </div>
        </div>
      </div>
      <div class="ui-g-5"></div>
      <div class="ui-g-7">
        <button pButton class="ui-button-success inline-block m-r-15"
                type="submit"
                [label]="'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.SAVE' | translate"></button>
      </div>
    </div>
  </form>
</p-dialog>
